export default "__VITE_ASSET__B5$hy5l2__"